import React from "react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import {
  Grid,
  Box,
  IconButton,
  Divider,
  Typography,
  Link,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginTop: theme.spacing(2),
    position: "static",
    bottom: 0,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  divider: {
    backgroundColor: theme.palette.primary.main,
  },
  iconButton: {
    width: 100,
    height: 100,
  },
  facebookIcon: {
    color: "#4267B2",
  },
  instagramIcon: {
    color: "#E1306C",
  },
  emailIcon: {
    color: "#D44638",
  },
  phoneIcon: {
    color: "#25D366",
  },
  addressIcon: {
    color: "#000000",
  },
  text: {
    color: theme.palette.text.primary,
  },
}));

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handlePhoneClick = () => {
    window.location.href = "tel:2310681694";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:kotogoniaeukarpias@gmail.com";
  };

  return (
    <Box className={classes.root}>
      <Divider className={classes.divider} />
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
            <IconButton
              className={classes.iconButton}
              aria-label="business"
              color="primary"
            >
              <BusinessIcon
                style={{
                  fontSize: 80,
                }}
                className={classes.addressIcon}
              />
            </IconButton>
            <Typography variant="h4" className={classes.text}>
              {t("pages.footer.address")}
            </Typography>
            <Typography variant="h4" className={classes.text}>
              Αγίου Γεωργίου 15
            </Typography>
            <Typography variant="h4" className={classes.text}>
              Ευκαρπία 564 29
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
            <IconButton
              className={classes.iconButton}
              aria-label="phone"
              color="primary"
              onClick={handlePhoneClick}
            >
              <PhoneIcon
                style={{
                  fontSize: 80,
                }}
                className={classes.phoneIcon}
              />
            </IconButton>
            <Typography variant="h4" className={classes.text}>
              {t("pages.footer.phone_number")}
            </Typography>
            <Typography variant="h4">
              <a
                href="tel:2310681694"
                className={classes.text}
                style={{
                  textDecoration: "none",
                }}
              >
                2310 68 1694
              </a>
            </Typography>
            <Typography variant="h4">
              <a
                href="tel:6986417369"
                className={classes.text}
                style={{
                  textDecoration: "none",
                }}
              >
                698 641 7369
              </a>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
            <IconButton
              className={classes.iconButton}
              aria-label="email"
              color="primary"
              onClick={handleEmailClick}
            >
              <EmailIcon
                style={{
                  fontSize: 80,
                }}
                className={classes.emailIcon}
              />
            </IconButton>
            <Typography variant="h4" className={classes.text}>
              {t("pages.footer.email_address")}
            </Typography>
            <Typography variant="h4">
              <a
                href="mailto:kotogoniaeukarpias@gmail.com"
                className={classes.text}
                style={{
                  textDecoration: "none",
                }}
              >
                kotogoniaeukarpias@gmail.com
              </a>
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box display="flex" justifyContent="center" mt={5}>
        <IconButton
          className={classes.iconButton}
          aria-label="facebook"
          color="primary"
        >
          <Link
            href="https://www.facebook.com/profile.php?id=100094328742187"
            target="_blank"
          >
            <FacebookIcon
              style={{
                fontSize: 80,
              }}
              className={classes.facebookIcon}
            />
          </Link>
        </IconButton>

        <IconButton
          className={classes.iconButton}
          aria-label="instagram"
          color="primary"
        >
          <InstagramIcon
            style={{
              fontSize: 80,
            }}
            className={classes.instagramIcon}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer;
